import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain-overlay flex min-h-screen items-center justify-center bg-[#111110] px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="rounded-md border border-[#D8CDBC] bg-[#FDFBF7] p-8 shadow-2xl sm:p-10">
          <div className="flex flex-col items-center text-center">
            <img src="/logo-stacked.jpeg" alt="The Olde Crow Boutique" className="h-36 w-auto rounded-md border border-[#D8CDBC] shadow-sm" />
            <h1 className="mt-4 font-serif text-2xl font-semibold text-[#292725]">Shopkeeper's Door</h1>
            <p className="mt-1 font-hand text-lg text-[#8C251C]">admin portal — staff only</p>
          </div>
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div>
              <label htmlFor="admin-email" className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-[#8A7E70]">Email</label>
              <input
                id="admin-email"
                data-testid="admin-login-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@oldecrowboutique.com"
                className="w-full rounded-md border border-[#D8CDBC] bg-[#FDFBF7] px-4 py-2.5 text-sm text-[#292725] placeholder:text-[#8A7E70] focus:border-[#C27803] focus:outline-none focus:ring-2 focus:ring-[#C27803]/30"
              />
            </div>
            <div>
              <label htmlFor="admin-password" className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-[#8A7E70]">Password</label>
              <input
                id="admin-password"
                data-testid="admin-login-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full rounded-md border border-[#D8CDBC] bg-[#FDFBF7] px-4 py-2.5 text-sm text-[#292725] placeholder:text-[#8A7E70] focus:border-[#C27803] focus:outline-none focus:ring-2 focus:ring-[#C27803]/30"
              />
            </div>
            {error && (
              <p data-testid="admin-login-error" className="rounded-md border border-[#8C251C]/40 bg-[#8C251C]/10 px-4 py-2.5 text-sm text-[#8C251C]">
                {error}
              </p>
            )}
            <button
              type="submit"
              data-testid="admin-login-submit-button"
              disabled={loading}
              className="w-full rounded-md bg-[#C27803] py-3 text-sm font-semibold text-[#FDFBF7] transition-colors hover:bg-[#9A5E02] disabled:opacity-60"
            >
              {loading ? "Unlocking..." : "Unlock the Shop Office"}
            </button>
          </form>
          <Link to="/" data-testid="admin-login-back-link" className="mt-6 block text-center text-xs text-[#8A7E70] hover:text-[#C27803]">
            ← Back to the shop
          </Link>
        </div>
      </div>
    </div>
  );
}
